var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"movie-gradient movie-goback",style:(_vm.style)},[_c('span',{staticClass:"arrow",style:(_vm.arrowStyle),on:{"click":function($event){$event.stopPropagation();return _vm.goBack()}}},[_c('i',{staticClass:"iconfont icon-xiangzuo"})]),_c('div',{staticClass:"page-title",style:(_vm.titleStyle)},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }